import type { VerifyResponse } from '@dynamic-labs/sdk-api-core';

import { getCore } from '../../../client/core/getCore';
import { getDefaultClient } from '../../../client/defaultClient';
import { createApiClient } from '../../apiClient';
import { updateAuthFromVerifyResponse } from '../../auth/updateAuthFromVerifyResponse';

/**
 * Refreshes the current user's data from the server.
 *
 * This function fetches the latest user information and token from the backend
 * updating the local user and token states with any changes.
 *
 * @param [client] - The Dynamic client instance. Only required when using multiple Dynamic clients.
 * @returns A promise that resolves to the verify response.
 */
export const refreshAuth = async (
  client = getDefaultClient()
): Promise<VerifyResponse> => {
  const core = getCore(client);
  const apiClient = createApiClient({}, client);

  const response = await apiClient.refreshAuth({
    environmentId: core.environmentId,
  });

  updateAuthFromVerifyResponse({ response }, client);

  return response;
};
